import routes from "@/libs/endPoint/rh/servidorRoutes.js";
import ApiServices from "@/services/uteis/ApiServices.js";
import RemocaoServices from "./RemocaoServices";
import store from "@/store/index.js";
class ServidorServices {
  constructor() {
    this.routes = routes;
    this.ApiServices = ApiServices;
    this.RemocaoServices = RemocaoServices;
    this.store;
  }

  async validarServidor(cpf, ano) {
    try {
      return this.RemocaoServices.validarServidor(cpf, ano);
    } catch (error) {
      console.error("Erro ao validar servidor:", error);
      throw error;
    }
  }
  async getServidor(params) {
    try {
      const url = this.routes.busca;

      const { data } = await this.ApiServices.get(url, params);
      if (data.success) {
        store.commit("storeServidor/setServidor", data.data);
      }
      return data;
    } catch (error) {
      console.error("Erro ao obter servidor:", error);
      throw error;
    }
  }
}

export default new ServidorServices();
